export default __webpack_public_path__ + "static/4-6d95a0ff1e65439284d59d0115bd9c49.jpg";